import React from 'react';
import NextStepFunction from './components/next-step-functional';
import './next-step.scss';

const NextStepEmployee = () => {
	return <NextStepFunction />;
};
export default NextStepEmployee;
